<app-form-select
  [formControl]="formControl"
  [data]="items"
  [templateType]="'tree'"
  [label]="'Processing Stage'"></app-form-select>
